module.exports = __webpack_public_path__ + "static/media/award-08.b1cdd25c.png";